import Avatar from "./Avatar";
import Icon from "./icons/Icon";
import "./SpielerKacheln.css";

const punkteText = (n) => (n === 1 ? "1 Punkt" : `${n} Punkte`);

/**
 * Bewertung: "Wer hatte recht?" — eine grosse Kachel pro Spieler.
 * eintraege: [{ key, name, score, an }], onToggle(key). keiner: Kachel
 * "Keiner" ({ an, onClick }) oder weglassen. Gewaehlt ist sie neutral statt
 * gruen markiert — es gibt ja keinen Punkt.
 * @category spiel
 */
export function SpielerKacheln({ eintraege, farbe, onToggle, keiner }) {
  return (
    <div className="kacheln">
      {eintraege.map((e) => (
        <button
          key={e.key}
          type="button"
          className={`kachel${e.an ? " an" : ""}`}
          onClick={() => onToggle(e.key)}
          aria-pressed={e.an}
        >
          <Avatar name={e.name} farbe={farbe(e.name)} />
          <span className="kachel-name">
            {e.name}
            <small>{punkteText(e.score)}</small>
          </span>
          {e.an && (
            <span className="kachel-plus">
              <Icon name="check" size={14} />
              +1
            </span>
          )}
        </button>
      ))}
      {keiner && (
        <button
          type="button"
          className={`kachel keiner${keiner.an ? " an" : ""}`}
          onClick={keiner.onClick}
          aria-pressed={!!keiner.an}
        >
          <span className="ava keiner-ava">
            <Icon name="minus" size={18} />
          </span>
          <span className="kachel-name">
            Keiner
            {keiner.an && <small>Kein Punkt</small>}
          </span>
          {keiner.an && (
            <span className="kachel-plus">
              <Icon name="check" size={14} />
            </span>
          )}
        </button>
      )}
    </div>
  );
}

export default SpielerKacheln;
